// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"7096ff62","443":"61c9d06f"}[chunkId] + ".chunk.js";
};